import { openDB } from "idb";

const DB_NAME = "maphunziro-offline-v1";
const DB_VERSION = 1;

export const STORES = {
  cache: "cache",
  outbox: "outbox",
  meta: "meta",
};

let dbPromise;

/**
 * IndexedDB for teacher offline data: TanStack Query persistence, entity cache, mutation outbox.
 */
export function getOfflineDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORES.cache)) {
          db.createObjectStore(STORES.cache, { keyPath: "key" });
        }
        if (!db.objectStoreNames.contains(STORES.outbox)) {
          const outbox = db.createObjectStore(STORES.outbox, {
            keyPath: "id",
            autoIncrement: true,
          });
          outbox.createIndex("createdAt", "createdAt");
        }
        if (!db.objectStoreNames.contains(STORES.meta)) {
          db.createObjectStore(STORES.meta, { keyPath: "key" });
        }
      },
    });
  }
  return dbPromise;
}
